import { render, staticRenderFns } from "./CustomReports.vue?vue&type=template&id=2a559ce8&scoped=true"
import script from "./CustomReports.vue?vue&type=script&lang=ts"
export * from "./CustomReports.vue?vue&type=script&lang=ts"
import style0 from "./CustomReports.vue?vue&type=style&index=0&id=2a559ce8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a559ce8",
  null
  
)

export default component.exports